import { Body1, Body2, UIText3 } from '@cian/ui-kit';
import { COMMON_COMPONENT_PROPS } from '../const';

export const uiTexts = {
  Body1: {
    ...COMMON_COMPONENT_PROPS,
    id: 'Body1',
    component: Body1,
    tagName: 'Body1',
    block: {
      label: 'Body1',
      category: 'Typography',
      content: '<Body1>Body1</Body1>',
    },
  },

  Body2: {
    ...COMMON_COMPONENT_PROPS,
    id: 'Body2',
    component: Body2,
    tagName: 'Body2',
    block: {
      label: 'Body2',
      category: 'Typography',
      content: '<Body2>Body2</Body2>',
    },
  },

  UIText3: {
    ...COMMON_COMPONENT_PROPS,
    id: 'uiText3',
    component: UIText3,
    tagName: 'uitext3',
    block: {
      label: 'UIText3',
      category: 'Typography',
      content: '<UIText3>UIText3</UIText3>',
    },
  },
};
